import { BUTTON_SETTINGS } from '../elements/link'

export const CARD_GRID = `
...on cardGrid_Entry {
  id
  typeHandle
  
  backgroundColor
  textAlign
  
  heading {
    html
  }
  description
  button {
    url
    title
  }
  ${ BUTTON_SETTINGS }
  
  cardGridContent {
    title
    ... on cardGridContent_Entry {
      id
      gridCards {
        ...on card_Entry {
          textColor
          heading {
            html
            plainText
          }
          descriptionColor: textColor2
          description
          backgroundImageDesktop {
            url
            title
          }
          backgroundImageMobile {
            url
            title
          }
        }
      }
    }
  }
  


}
`